<script setup>
import { computed } from "vue";
import IconCheckmark from "@components/icons/Checkmark.vue";

const props = defineProps({
    name: {
        type: String,
        required: true,
    },
    hex: {
        type: String,
        required: true,
    },
});

const isCorrect = computed(() => props.name.toLowerCase() === "correct");
</script>

<template>
    <span
        class="body-xs inline-flex items-center justify-end gap-1 font-bold uppercase"
        :style="{ color: hex }"
    >
        {{ name }}
        <IconCheckmark v-if="isCorrect" class="size-3" />
    </span>
</template>
